import { APP_BASE_PATH } from './appBasePath';

// Returns the path remainder after APP_BASE_PATH, or null if pathname isn't
// under the base path at all. An empty string means exactly the base path
// itself (with or without a trailing slash) — most callers treat that the
// same as null (both falsy) unless they need to distinguish "not under
// base" from "is the bare base path" (isNoIndexed does).
export const stripBasePath = (pathname: string | undefined | null): string | null => {
  if (!pathname) return null;
  const base = APP_BASE_PATH.endsWith('/') ? APP_BASE_PATH.slice(0, -1) : APP_BASE_PATH;
  if (pathname !== base && !pathname.startsWith(`${base}/`)) return null;
  return pathname.slice(base.length).replace(/^\/+/, '');
};

// Path prefixes (under APP_BASE_PATH) on which Shell hides Header + Footer
// because Appraisal renders its own chrome on these routes.
// Match is segment-boundary-anchored — `getoffer` matches `/getoffer` and
// `/getoffer/...` but not `/getofferwithsuffix`.
export const TRANSPOSED_PATH_PREFIXES: readonly string[] = [
  'getoffer',
  'refresh',
  'offer/edit',
  'offer/addvin',
  'offer/projection',
  'offer/report',
  'offer/calculate',
  'offer/token/calculate'
];

export const shouldTransposeChrome = (pathname: string | undefined | null): boolean => {
  const rest = stripBasePath(pathname);
  if (!rest) return false;
  return TRANSPOSED_PATH_PREFIXES.some(prefix => rest === prefix || rest.startsWith(`${prefix}/`));
};

// Routes that render the Footer AND whose primary content arrives slowly
// enough that the Footer push-down is a measurable CLS source. `offer` is
// the bare `/offer/:id` form.
export const OFFER_FOOTER_GATED_PREFIXES: readonly string[] = [
  'offer/track',
  'offer/acquisition',
  'offer/token',
  'offer'
];

export const isOfferFooterGated = (pathname: string | undefined | null): boolean => {
  const rest = stripBasePath(pathname);
  if (!rest) return false;
  // Transposed routes don't render the Footer at all, so gating is moot.
  if (shouldTransposeChrome(pathname)) return false;
  return OFFER_FOOTER_GATED_PREFIXES.some(
    prefix => rest === prefix || rest.startsWith(`${prefix}/`)
  );
};
